import React, { Fragment } from 'react';
import MTDReportView from './MTDReportView';

// Thin route entry — the V3 shell lives inside the view.
const MTDReport = () => (
    <Fragment>
        <MTDReportView />
    </Fragment>
);

export default MTDReport;
